import CommonHelmet from '@src/components/CommonHelmet';
import Terms from '@src/features/company/footer/Terms';

function FooterTerms() {
  return (
    <>
      <CommonHelmet />
      <Terms />
    </>
  );
}

export default FooterTerms;
